<template>
  <div class="private-inner  w-1200">
    <div class="service-section" >
      <div class="service-card" v-if="customerInfo.yewu">
        <img :src="customerInfo.yewu.avatar" alt="业务员头像" class="avatar"/>
        <div class="user-info">
          <div class="info-item">
            <label>专属业务：</label>
            <span>{{ customerInfo.yewu.name }}</span>
          </div>
          <div class="info-item" @click="copyText(customerInfo.yewu.mobile)">
            <label>联系方式：</label>
            <span>{{ customerInfo.yewu.mobile }} <i class="el-icon-document-copy blue"></i></span>
          </div>
          <div class="info-item" @click="copyText(customerInfo.yewu.qq)">
            <label>QQ号码：</label>
            <span>{{ customerInfo.yewu.qq }} <i class="el-icon-document-copy blue"></i></span>
          </div>
        </div>
        <img :src="customerInfo.yewu.qrcode" alt="业务员二维码" class="qrcode"/>
      </div>
    </div>

    <div class="service-section">
      <div class="service-card" v-if="customerInfo.kefu">
        <img :src="customerInfo.kefu.avatar" alt="客服头像" class="avatar"/>
        <div class="user-info">
          <div class="info-item">
            <label>专属客服：</label>
            <span>{{ customerInfo.kefu.name }}</span>

          </div>
          <div class="info-item" @click="copyText(customerInfo.kefu.mobile)">
            <label>联系方式：</label>
            <span>{{ customerInfo.kefu.mobile }}  <i class="el-icon-document-copy blue"></i></span>
          </div>
          <div class="info-item" @click="copyText(customerInfo.kefu.qq)">
            <label>QQ号码：</label>
            <span>{{ customerInfo.kefu.qq }} <i class="el-icon-document-copy blue"></i></span>
          </div>
        </div>
        <img :src="customerInfo.kefu.qrcode" alt="客服二维码" class="qrcode"/>
      </div>
    </div>
  </div>
</template>

<script>
import {getMyCustomerService} from "@/api/modules/user";

export default {
  name: "privateInner",
  data() {
    return {
      customerInfo: {},
    };
  },
  created() {
    this.getMyCustomer();
  },
  methods: {
    copyText(text) {
      if (text) {
        this.$utils.copyText(text, this);
      } else {
        this.$message.warning({
          message: "复制信息不存在",
          duration: 2000,
          offset: 200,
        });
      }
    },
    getMyCustomer() {
      getMyCustomerService().then((res) => {
        console.log('res', res)
        if (res.data.code == 10000) {
          this.customerInfo = res.data.data;
          console.log(this.customerInfo)
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
.blue {
  color: #4393FE;
}

.private-inner {
  margin-top: 20px;
  background-color: #f5f5f5;
  display: flex;
  justify-content: space-between;

  .service-section {
    width: 49%;

    &:last-child {
      margin-bottom: 0;
    }

    .section-title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;
    }

    .service-card:hover {
      box-shadow: 0 8px 32px rgba(64, 158, 255, 0.16),
      0 3px 12px rgba(0, 0, 0, 0.08);
      transform: translateY(-5px);
    }

    .service-card {
      display: flex;
      align-items: center;
      background: #fff;
      padding: 20px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transition: transform 0.2s;


      .avatar {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        object-fit: cover;
        margin-right: 20px;
        border: 3px solid #eee;
      }

      .user-info {
        flex: 1;

        .info-item {
          margin-bottom: 8px;
          display: flex;

          &:last-child {
            margin-bottom: 0;
          }

          label {
            font-weight: bold;
            color: #666;
            width: 80px;
            flex-shrink: 0;
          }

          span {
            color: #333;
          }
        }
      }

      .qrcode {
        width: 100px;
        height: 100px;
        margin-left: 20px;
        border: 1px solid #eee;
        padding: 5px;
      }
    }
  }

  // 响应式设计
  @media (max-width: 768px) {
    padding: 10px;

    .service-section {
      .service-card {
        flex-direction: column;
        text-align: center;

        .avatar {
          margin-right: 0;
          margin-bottom: 15px;
        }

        .user-info {
          margin-bottom: 15px;

          .info-item {
            justify-content: center;

            label {
              width: auto;
              margin-right: 5px;
            }
          }
        }

        .qrcode {
          margin-left: 0;
        }
      }
    }
  }
}
</style>
